import React from 'react';
import { FaEnvelope, FaPhone, FaUser } from 'react-icons/fa';
import './ContactDetail.css';
import ContentUnitTag from '../common/ContentUnitTag';
import { contactEntryKey } from '../../platform/contactEmails';

function formatDate(date) {
  if (!date) return '';
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleString('sl-SI', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function ContactDetail({ contact }) {
  return (
    <article className="contact-detail platform-content-detail">
      <div className="platform-content-detail-card">
        <div className="platform-content-detail-card__header">
          <h2 className="platform-content-detail-card__title">Kontakt</h2>
        </div>

        <div className="platform-content-detail__body">
          <div className="platform-content-detail__meta">
            <ContentUnitTag item={contact} />
            {contact.createdAt && (
              <>
                <span className="platform-content-detail__meta-separator">·</span>
                <span>Dodano {formatDate(contact.createdAt)}</span>
              </>
            )}
          </div>

          <dl className="contact-detail__fields">
            <div className="contact-detail__field">
              <dt>
                <FaUser aria-hidden="true" />
                Ime
              </dt>
              <dd>{contact.name}</dd>
            </div>

            <div className="contact-detail__field">
              <dt>
                <FaEnvelope aria-hidden="true" />
                Elektronski naslov
              </dt>
              <dd className="contact-detail__entries">
                {contact.emails.map((entry) => (
                  <div key={contactEntryKey(entry)} className="contact-detail__entry">
                    <span className="contact-detail__entry-label">{entry.label}</span>
                    <a href={`mailto:${entry.value}`}>{entry.value}</a>
                  </div>
                ))}
              </dd>
            </div>

            <div className="contact-detail__field">
              <dt>
                <FaPhone aria-hidden="true" />
                Telefon
              </dt>
              <dd className="contact-detail__entries">
                {contact.phones.map((entry) => (
                  <div key={contactEntryKey(entry)} className="contact-detail__entry">
                    <span className="contact-detail__entry-label">{entry.label}</span>
                    <a href={`tel:${entry.value}`}>{entry.value}</a>
                  </div>
                ))}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </article>
  );
}

export default ContactDetail;
